<template>
  <el-dialog
    :title="title"
    :visible="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    width="500px"
    @close="onClose"
  >
    <el-form
      ref="passwordForm"
      :model="form"
      :rules="rules"
      label-width="140px"
    >
      <el-form-item label="Старый пароль" prop="oldPassword">
        <el-input
          v-model="form.oldPassword"
          type="password"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item label="Новый пароль" prop="newPassword">
        <el-input
          v-model="form.newPassword"
          type="password"
          show-password
        ></el-input>
      </el-form-item>

      <el-form-item label="Подтверждение нового пароля" prop="confirmPassword">
        <el-input
          v-model="form.confirmPassword"
          type="password"
          show-password
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="password-requirements">
      <p class="requirements-title">Требования к новому паролю</p>
      <ul class="requirements-list">
        <li>Длина: от 13 символов</li>
        <li>
          Состав: должны присутствовать 3 вида символов:
          <ul>
            <li>Латинские буквы (A–Z, a–z)</li>
            <li>Цифры (0–9)</li>
            <li>Спецсимволы (например, #, $, %, &)</li>
          </ul>
        </li>
        <li>История паролей: Нельзя использовать свой текущий пароль</li>
        <li>Лимит на смену: 1 раз в 24 часа</li>
      </ul>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="onClose">Отмена</el-button>
      <el-button type="primary" :loading="loading" @click="onSubmit"
        >Сменить пароль</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { passwordChange } from "@/api/account";

export default {
  name: "ChangePasswordModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    userId: {
      type: [Number, String],
      required: false,
      default: null,
    },
    title: {
      type: String,
      default: "Смена пароля",
    },
  },
  data() {
    const validatePasswordComplexity = (rule, value, callback) => {
      if (!value) {
        callback(new Error("Пожалуйста, введите новый пароль"));
        return;
      }

      // Проверка минимальной длины
      if (value.length < 14) {
        callback(new Error("Пароль должен содержать минимум 14 символов"));
        return;
      }

      // Проверка наличия как минимум 3 типов символов:
      // 1. Латинские буквы (A-Z, a-z)
      // 2. Цифры (0-9)
      // 3. Специальные символы
      const latinLetterRegex = /[a-zA-Z]/;
      const digitRegex = /[0-9]/;
      const specialCharRegex = /[^a-zA-Z0-9]/;

      let charTypesCount = 0;
      if (latinLetterRegex.test(value)) charTypesCount++;
      if (digitRegex.test(value)) charTypesCount++;
      if (specialCharRegex.test(value)) charTypesCount++;

      if (charTypesCount < 3) {
        callback(
          new Error(
            "Пароль должен содержать: латинские буквы, цифры и спецсимволы"
          )
        );
        return;
      }

      callback();
    };

    const validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.newPassword) {
        callback(new Error("Пароли не совпадают"));
      } else {
        callback();
      }
    };

    return {
      loading: false,
      form: {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      },
      rules: {
        oldPassword: [
          {
            required: true,
            message: "Пожалуйста, введите старый пароль",
            trigger: "blur",
          },
        ],
        newPassword: [
          {
            required: true,
            validator: validatePasswordComplexity,
            trigger: "blur",
          },
        ],
        confirmPassword: [
          {
            required: true,
            message: "Пожалуйста, подтвердите новый пароль",
            trigger: "blur",
          },
          {
            validator: validateConfirmPassword,
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
      this.resetForm();
    },
    resetForm() {
      this.form = {
        oldPassword: "",
        newPassword: "",
        confirmPassword: "",
      };

      // Сброс валидации
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.resetFields();
      }
    },
    onSubmit() {
      this.$refs.passwordForm.validate(async (valid) => {
        if (valid) {
          this.loading = true;

          try {
            await passwordChange({
              old_password: this.form.oldPassword,
              new_password: this.form.newPassword,
              repeat_password: this.form.newPassword,
            });

            this.$message.success("Пароль успешно изменен!");

            this.onClose();
            this.$emit("password-changed");
          } catch (error) {
            console.error(error);
          } finally {
            this.loading = false;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.password-requirements {
  padding: 10px;
  background-color: #f8f9fa;
  font-size: 13px;

  .requirements-title {
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 5px;
  }

  .requirements-list {
    padding-left: 20px;
    margin: 0;
  }

  .requirements-list li {
    margin-bottom: 3px;
    list-style: disc;
  }

  .requirements-list ul {
    padding-left: 15px;
    margin: 3px 0;
  }
}
</style>
